import {db} from '@/firebase'

export default {
    getCocinas({commit}){
        let devolver = [];
        return db.collection('tipococinas').get()
        .then((res) => {
            res.forEach(doc => {
                let aux = doc.data();
                aux.id = doc.id;
                devolver.push(aux);
            });
            commit('setCocinas',devolver)
        })
    },
    addCocina({rootState},cocina){
        let id = cocina.id;
        delete cocina.id;
        var ref = null
        if (id){
            ref = db.collection('tipococinas').doc(id).set(cocina,{merge:true})
        } else {
            ref = db.collection('tipococinas').add(cocina)
        }
        return ref;
    },
    deleteCocina({},cocina){
        return db.collection('tipococinas').doc(cocina.id).delete()
    }
}